"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721Transfer = exports.ERC20Transfer = exports.NativeToken = exports.TokenEvent = void 0;
const token_details_1 = require("../token/token_details");
/**
 * Represents different types of token events, such as native token events,
 * ERC-20 token transfers, and ERC-721 token transfers.
 */
class TokenEvent {
    constructor(data) {
        this.symbol = data.symbol;
        this.name = data.name;
        this.address = data.address;
        this.value = data.value;
        this.to = data.to;
        this.from = data.from;
    }
    /**
     * Factory method to create an instance of TokenEvent from a JSON object.
     * @param json The JSON object to parse.
     * @returns An instance of one of the TokenEvent subclasses based on the type.
     */
    static fromJson(json) {
        switch (json.type) {
            case 'native':
                return new NativeToken(json);
            case 'ERC-20':
                return new ERC20Transfer(json);
            case 'ERC-721':
                return new ERC721Transfer(json);
            default:
                throw new Error('Unsupported token event type');
        }
    }
}
exports.TokenEvent = TokenEvent;
class NativeToken extends TokenEvent {
    constructor(data) {
        var _a;
        super(data);
        this.decimals = (_a = data.decimals) !== null && _a !== void 0 ? _a : 18;
    }
}
exports.NativeToken = NativeToken;
class ERC20Transfer extends TokenEvent {
    constructor(data) {
        super(data);
        this.decimals = data.decimals;
        this.symbol = data.symbol;
        this.name = (0, token_details_1.nameFromJson)(data.name);
        this.address = (0, token_details_1.addressFromJson)(data.address);
        this.value = (0, token_details_1.amountFromJson)(data.value);
    }
}
exports.ERC20Transfer = ERC20Transfer;
class ERC721Transfer extends TokenEvent {
    constructor(data) {
        super(data);
        this.tokenId = data.tokenId;
        this.symbol = data.symbol;
        this.name = (0, token_details_1.nameFromJson)(data.name);
        this.address = (0, token_details_1.addressFromJson)(data.address);
        this.value = (0, token_details_1.amountFromJson)(data.value);
    }
}
exports.ERC721Transfer = ERC721Transfer;
